import { configureStore } from '@reduxjs/toolkit';
import { scenarioSlice } from './features/scenario.slice';
import { exposeStoreForPerf, initPerfState, perfMiddleware } from './perf';

initPerfState();

export const store = configureStore({
    reducer: {
        [scenarioSlice.name]: scenarioSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(perfMiddleware),
});

exposeStoreForPerf(store);
